<template>
    <div>
        <section class="section-title">
            <div class="section-container" style="height: calc(100vh - 66px);">
                <div class="title-container">
                    <h1 class="title">Stakepool.fr</h1>
                    <h2 class="subtitle">Le media crypto <span class="text-danger">indépendant</span><br />financé par vos investissements</h2>
                </div>

                <WorldAnimation />
            </div>
        </section>

        <section class="section-mission">
            <div class="container-fluid w-75">
                <div class="row">
                    <div class="col-12">
                        <div class="border-container">
                            <h2 class="container-title">Notre mission: le journalisme (crypto) indépendant</h2>
                            <h2 class="container-mobile-title">Le journalisme (crypto) indépendant</h2>
                            <p>
                                Le monde de la cryptomonnaie est une jungle dans laquelle on trouve pêle-mêle des <b>projets incroyablement innovants</b>, des <b>arnaques</b>, des <b>investissements juteux</b>, des projets
                                <b>qui ne valent pas un clou</b>, et bien d'autres bizarreries. Jour après jour, nous nous efforçons d'investiguer, de décrypter, d'expliquer les concepts, et d'analyser pour nos lecteurs.<br /><br />

                                <b>L'éternel problème du financement gangrène le journalisme</b>, qui choisit en général, soit de se restreindre à un public de privilégiés (accès payant), soit de corrompre son contenu (publicités, articles
                                sponsorisés), soit de devenir un organe d'influence (financement externe). Le monde de la cryptomonnaie est dangereux, il vous faut des médias dans lesquels vous pouvez avoir confiance. Ici, <b>pas de publicité</b>,
                                <b>pas d'articles sponsorisés</b>, <b>pas de souscription ou d'accès payant</b>.<br /><br />

                                Dans ce monde dangereux, nous tentons de publier du contenu gratuit et indépendant, disssocié de nos sources de revenus (si nous on créeons une un jour).
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import WorldAnimation from "~/components/WorldAnimation.vue";

export default {
    components: {
        WorldAnimation
    },
    methods: {
        toggleDelegate() {
            let delegateDiv = document.getElementById("delegate");
            if (delegateDiv.style.display === "none") {
                $("#delegate").show();
            } else {
                $("#delegate").hide();
            }
        }
    },
    async asyncData({ $content, params }) {
        const newsList = await $content("actu")
            .only(["title", "path"])
            .sortBy("date", "desc")
            .limit(5)
            .fetch();

        const articleList = await $content("articles")
            .only(["title", "path"])
            .sortBy("date", "desc")
            .limit(5)
            .fetch();

        return {
            newsList,
            articleList
        };
    }
};
</script>

<style>
.section-blockchain .btn {
    margin: 10px;
}

.highlight {
    background-color: #e4e4e4;
}

.section-mission {
    margin-bottom: 40px;
}

.section-doc {
    margin-bottom: 40px;
}

.section-help .col-12 {
    margin-bottom: 40px;
}

section ul {
    margin: 0;
}

section ul {
    list-style-type: none;
}

section ul > li {
    text-indent: -30px;
}

section ul > li:before {
    content: "-";
    text-indent: -30px;
}

#delegate {
    padding: 30px;
}

.title-container {
    display: block;
    position: absolute;
    top: calc(50vh - 165px);
    padding-left: 10%;
}

.title-container h1,
.title-container h2 {
    display: block;
}

h2 {
    margin-bottom: 25px;
}

section.section-title {
    width: 100%;
    height: 100%;
    position: relative;
}

.section-container {
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    justify-content: left;
    align-items: left;
    text-align: center;
}

.title {
    font-family: "Quicksand", "Source Sans Pro", -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        sans-serif;
    font-display: swap;
    display: block;
    font-weight: 300;
    font-size: 100px;
    color: #35495e;
    letter-spacing: 1px;
}

.subtitle {
    font-weight: 300;
    font-size: 42px;
    color: #526488;
    word-spacing: 5px;
    padding-bottom: 15px;
}

.links {
    padding-top: 15px;
}

.padding-top-light {
    padding-top: 40px;
}

a.oneline {
    display: -webkit-box;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-width: 100%;
    max-height: 21px;
}

a.oneline::before {
    content: "-";
}

@media (max-device-width: 1024px) {
    h1.title {
        font-size: 60px;
    }

    h2.subtitle {
        font-size: 24px;
    }

    .title-container {
        padding-left: 0px;
        left: 0;
        right: 0;
    }

    #canvas-container {
        padding-left: 0;
        width: 100%;
    }

    .w-75 {
        width: 100% !important;
    }

    .container-fluid {
        padding: 15px;
    }

    h2 {
        margin-top: 20px;
    }

    h2:first-child {
        margin-top: 0px;
    }

    h3 {
        font-size: 18px;
    }

    .section-doc {
        margin-bottom: 0;
    }

    .section-help .col-12 {
        margin-bottom: 30px;
    }
}
</style>
